import { render, staticRenderFns } from "./GuideBanner.vue?vue&type=template&id=10542e08&scoped=true&"
import script from "./GuideBanner.vue?vue&type=script&lang=js&"
export * from "./GuideBanner.vue?vue&type=script&lang=js&"
import style0 from "./GuideBanner.vue?vue&type=style&index=0&id=10542e08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10542e08",
  null
  
)

export default component.exports